export const stats = [
  { value: '+640', label: 'Ready-to-Print Units & Activities' },
  { value: '+1,500', label: 'Satisfied Dance Educators' },
  { value: '3,800+', label: 'Preparation Hours Saved' },
  { value: '98%', label: 'Recommendation Rate' },
]

export const differenceStats = [
  { value: '+640', label: 'Movement Units & Activities (All Levels)' },
  { value: '6', label: 'Complete Digital Volumes (Full Curriculum)' },
  { value: '100%', label: 'Immediate Digital Download' },
]

export const beforeItems = [
  'Sunday afternoons lost: hours spent planning every single lesson from scratch, searching across 10 different websites',
  "Improvised exercises: combinations that don't flow because you lack clear instructions or professional visual aids",
  'Disjointed progress: no clear technical connection between different age groups and skill levels',
  'Evaluation nightmares: struggling to track student progress or create assessments that actually work',
  'Burnout: feeling mentally overloaded before the music even starts',
]

export const afterItems = [
  '5-minute prep: review the material and walk into the studio with total professional confidence',
  'Engaging movement labs: creative activities and technical exercises with step-by-step instructions',
  'Visual dance infographics: high-resolution anatomy and technique maps integrated into every unit',
  'Turnkey evaluations: rubrics, trackers and certificates 100% ready to print and hand out',
  'Unified vision: a complete system to plan less and teach with more passion and precision',
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 Volumes Covering All Ages',
    text: 'A complete progressive curriculum from The Creative Spark (Preschool) to Professional Excellence (Elite / Ages 14+)',
  },
  {
    emoji: '🎭',
    title: 'Choreography & Performance Kit',
    text: 'Technical sheets for building routines, stage presence exercises and rehearsal organization guides',
  },
  {
    emoji: '✏️',
    title: '«Ready-to-Go» Teacher Scripts',
    text: 'Professional cues that tell you exactly how to explain complex movements to every age group',
  },
  {
    emoji: '📐',
    title: 'Visual Dance: Infographics & Posters',
    text: '8K resolution graphics that make body alignment, anatomy and dance positions easy to understand',
  },
  {
    emoji: '📊',
    title: 'Assessment & Inclusion Tools',
    text: 'Skill checklists, student trackers and simplified versions for inclusive teaching',
  },
  {
    emoji: '🔑',
    title: 'Master Answer Keys',
    text: 'Full solutions and teacher notes for every worksheet for instant, stress-free management',
  },
]

export const bonuses = [
  {
    title: 'The 12-Month Dance Class Roadmap Planner™',
    was: '$19 USD',
    text: 'Organize all 6 volumes into a clear, year-long professional teaching plan',
  },
  {
    title: 'First Week Dance Class Starter Kit™',
    was: '$27 USD',
    text: 'Everything you need for a perfect first impression: intro activities, routines and setup tools',
  },
  {
    title: 'Parent Progress Communication Pack™',
    was: '$36 USD',
    text: "Professional templates to keep parents informed and satisfied with their child's growth",
  },
  {
    title: 'The Print & Prep Dance Studio Binder™',
    was: '$17 USD',
    text: 'The ultimate organization system to keep your entire curriculum in one physical place',
  },
  {
    title: 'Student Level Placement & Quick Assessment Kit™',
    was: '$17 USD',
    text: 'Evaluate and place every student in the right level with absolute confidence',
  },
]

export const offerRows = [
  { label: 'DANCE READY™ Pack (6 Digital Volumes)', value: '$77 USD' },
  { label: '5 Exclusive Strategic Bonuses', value: '$116 USD' },
]

export const testimonials = [
  {
    quote:
      'I finally got my weekends back. The lesson plans are progressive and the children absolutely love the visual pose cards.',
    name: 'Sarah M.',
    location: 'Dance Studio Owner 🇬🇧',
  },
  {
    quote:
      'The technique maps are a game-changer for my visual learners. Truly professional material.',
    name: 'David B.',
    location: 'Ballet Instructor 🇺🇸',
  },
  {
    quote:
      "From the tiny tots to my senior competitive team, this is the best investment I've made for my classes.",
    name: 'Elena V.',
    location: 'Independent Teacher 🇦🇺',
  },
]
